import Modal from 'utils/packages/Modal';
const strings = {
    title: 'Are you outside the UK?',
    subtitle: 'To protect your data, we can only activate your credit score while you’re in the UK without an active VPN. Please turn off your VPN and continue, or try again when you’re back in the UK.',
    tryLater: 'I’ll try later',
    continue: 'Continue',
};
const CreditScoreOutsideUkModal = {
    show: ({ onContinue, onTryLater, }) => {
        Modal.showConfirmation({
            title: strings.title,
            subtitle: strings.subtitle,
            // With a cancel button present, the confirm renders as the top light
            // button and the cancel as the bottom solid one — so "I'll try later"
            // is the confirm and Continue the cancel.
            confirmButtonTitle: strings.tryLater,
            cancelButtonTitle: strings.continue,
            onConfirm: onTryLater,
            onPressCancel: onContinue,
        });
    },
};
export default CreditScoreOutsideUkModal;
